import React from 'react';

import useSelectableVideoConsultationsList from './useSelectableVideoConsultationsList';
import {
  useNewPetoloFormDataValue,
  PETOLO_VIDEO_CONSULTATION_ID,
  PETOLO_NO_SUITABLE_VIDEO_CONSULTATION,
  PETOLO_CUSTOMER_NOTE,
  PET_HEALTH_TREATMENT_CATEGORIES,
} from '../../claimFormData/newClaimFormData';
import {
  useSelectVideoConsultationBackButtonLink,
  useSelectVideoConsultationNextButtonLink,
} from './selectVideoConsultationHooks';

import ListWithRadioButton from '../common/ListWithRadioButton';

export default function SelectVideoConsultation() {
  const selectableVideoConsultationsList = useSelectableVideoConsultationsList();

  const [treatmentCategories] = useNewPetoloFormDataValue(PET_HEALTH_TREATMENT_CATEGORIES);

  const [selectedVideoConsultationId, setSelectedVideoConsultationId] = useNewPetoloFormDataValue(
    PETOLO_VIDEO_CONSULTATION_ID
  );
  const videoConsultationId =
    selectedVideoConsultationId === PETOLO_NO_SUITABLE_VIDEO_CONSULTATION
      ? ''
      : selectedVideoConsultationId;

  const [, /* customerNote */ setCustomerNote] = useNewPetoloFormDataValue(PETOLO_CUSTOMER_NOTE);

  const handleSelectedVideoConsultationIdChange = (value) => {
    if (value !== PETOLO_NO_SUITABLE_VIDEO_CONSULTATION) {
      setCustomerNote('');
    }
    setSelectedVideoConsultationId(value);
  };

  const backButtonLink = useSelectVideoConsultationBackButtonLink();
  const nextButtonLink = useSelectVideoConsultationNextButtonLink(
    videoConsultationId,
    treatmentCategories
  );

  return (
    <ListWithRadioButton
      name="video_consultation"
      backButtonLink={backButtonLink}
      nextButtonLink={nextButtonLink}
      pageTitleId="petolo.new_claim.select_video_consultation.page.title"
      listConfig={selectableVideoConsultationsList}
      selected={selectedVideoConsultationId}
      setSelected={handleSelectedVideoConsultationIdChange}
    />
  );
}
